import React from 'react';
import { css } from 'linaria';
import { Typography, ProductCardsSection, ProductCardStructure } from 'common/components';
import { INTERIOR_DOORS_OPENING_TYPES_LIST } from './interior-doors-opening-types-constants';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../interior-doors-constants';

const openingTypesProduct = css`
  && {
    width: 163px;

    @media (--only-desktop) {
      width: 205px;
    }

    @media (--only-tablet) {
      width: 193px;
    }

    @media (--only-mobile) {
      width: 204px;
    }
  }
`;

const openingTypesImage = css`
  width: 144px;
  height: 144px;
  margin-bottom: 24px;
`;

const openingTypesName = css`
  width: 144px;
`;

export const InteriorDoorsOpeningTypes = () => (
  <ProductCardsSection
    elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
    description="Подберём двери с&nbsp;подходящим механизмом и&nbsp;стороной открывания, чтобы вам было удобно."
    productList={INTERIOR_DOORS_OPENING_TYPES_LIST}
    renderProductCard={({ alt, imgSrc, name }: ProductCardStructure) => (
      <>
        <img alt={alt} className={openingTypesImage} src={imgSrc} title={name} />
        <Typography adaptive={false} className={openingTypesName} size="subtitle" variant="m">
          {name}
        </Typography>
      </>
    )}
    swiperSlideClassName={openingTypesProduct}
    title="Различные типы открывания"
  />
);
